export var ScopeInclude = {};
//# sourceMappingURL=Scope.js.map